<template>
    <div>
        <VJoyLabel :text="$t('profile.section.skill.set.edition.topskills.title')">
            <template #label-legend>
                {{
                    $t('profile.section.header.edit.topskills.sub.label', {
                        minSkills: skillSetTopSkills.min,
                        maxSkills: skillSetTopSkills.max,
                    })
                }}
            </template>
        </VJoyLabel>
        <EditGlobalSkills
            v-model="model"
            :rules-global-skill-label-min-length="skillSetGlobalSkillLabel.min"
            :rules-global-skill-label-max-length="skillSetGlobalSkillLabel.max"
            :show-label="false"
            :show-tag-list="true"
            :show-occurences="true"
            :disabled="model.length >= skillSetTopSkills.max"
            :invalid="errors.length > 0"
            :errors="errors"
        />
        <SkillsSuggestions
            v-show="model.length < skillSetTopSkills.max"
            :skills="model"
            :description="headline"
            @skill-selected="handleSkillSuggestedSelected"
        />
    </div>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {VJoyLabel} from '@maltjoy/core-vue';
    import EditGlobalSkills from '~/components/edit/skill-set/EditGlobalSkills.vue';
    import SkillsSuggestions from '~/features/experience/ui/edition/SkillsSuggestions.vue';
    import {type Skill} from '~/openapi';
    import {useRulesStore} from '~/store/rules/rulesStore';

    const {skillSetTopSkills, skillSetGlobalSkillLabel} = storeToRefs(useRulesStore());

    const model = defineModel<Skill[]>({required: true});
    defineProps<{
        errors: string[];
        headline: string;
    }>();

    function handleSkillSuggestedSelected(suggestedSkill: Skill) {
        model.value = [...model.value, suggestedSkill];
    }
</script>
